import { useUserLogs } from './hooks/useUserLogs';
import UserLogsView from './view';

export default function UserLogs({ userId, user }) {
    const state = useUserLogs(userId);
    return <UserLogsView {...state} user={user} />;
}
